import { render, staticRenderFns } from "./DoctorsNoteCard.vue?vue&type=template&id=1c34adc1&scoped=true&"
import script from "./DoctorsNoteCard.vue?vue&type=script&lang=js&"
export * from "./DoctorsNoteCard.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsNoteCard.vue?vue&type=style&index=0&id=1c34adc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34adc1",
  null
  
)

export default component.exports